import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHorizontalBarChartLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.24902 21.1182C5.24902 21.5324 4.91324 21.8682 4.49902 21.8682C4.08481 21.8682 3.74902 21.5324 3.74902 21.1182V14.518V9.71729V3.11816C3.74902 2.70395 4.08481 2.36816 4.49902 2.36816C4.91324 2.36816 5.24902 2.70395 5.24902 3.11816V4.16846H9.50139C10.4392 4.16846 11.2517 4.9054 11.2517 5.87874V8.96729H19.5001C20.4379 8.96729 21.2504 9.70423 21.2504 10.6776V13.5577C21.2504 14.5311 20.4379 15.268 19.5001 15.268H16.2508V18.358C16.2508 19.3314 15.4383 20.0683 14.5005 20.0683H5.24902V21.1182ZM5.24902 15.268H14.7508V18.358C14.7508 18.4459 14.6681 18.5683 14.5005 18.5683H5.24902V15.268ZM15.5258 13.768H19.5001C19.6677 13.768 19.7504 13.6456 19.7504 13.5577V10.6776C19.7504 10.5897 19.6677 10.4673 19.5001 10.4673H10.5551C10.5374 10.4686 10.5196 10.4692 10.5017 10.4692H5.24902V13.7676H15.5008C15.5092 13.7676 15.5175 13.7677 15.5258 13.768ZM9.75166 8.96729V5.87874C9.75166 5.79091 9.66899 5.66846 9.50139 5.66846H5.24902V8.96729H9.75166Z",
		fill: "currentColor"
	})
});
export default SvgHorizontalBarChartLine;
